export const coordsToKey = (q, r) => {
  return `${q},${r}`
}